// Models
import Model from './Model'
import CardLimitsPeriod from './CardLimitsPeriod'

class CardLimits extends Model {
  get formatters () {
    return {
      purchaseLimitActive: (data) => data && new CardLimitsPeriod(data),
      purchaseLimitPending: (data) => data && new CardLimitsPeriod(data),
      withdrawalLimitActive: (data) => data && new CardLimitsPeriod(data),
      withdrawalLimitPending: (data) => data && new CardLimitsPeriod(data)
    }
  }

  get schema () {
    return [
      'purchaseLimitActive',
      'purchaseLimitPending',
      'purchaseLimitRemaining',
      'withdrawalLimitActive',
      'withdrawalLimitPending',
      'withdrawalLimitRemaining',
      'withdrawals',
      'contactless',
      'currency'
    ]
  }
}

export default CardLimits
